import { API_GET_CITIES_POSTALCODE } from "actions/city.js";

export function getCitiesByPostalCode(postalCodeId, work = false) {
	return {
		type: API_GET_CITIES_POSTALCODE,
		work,
		payload: {
			request: {
				url: `/cities/postalCode/${postalCodeId}/`,
				method: "GET",
			},
		},
	};
}
export function resetCities() {
	return {
		type: "RESET_CITIES",
	};
}
export function resetWorkCities() {
	return {
		type: "RESET_WORK_CITIES",
	};
}
